<template>
  <section class="profit-centers">
    <ContentBox class="content-box">
      <div class="row">
        <div class="col-20">
          <h4 class="h4 font-component-headline">{{ $t('globalSettings.profitCenters.headline') }}</h4>
        </div>
      </div>
      <div class="row _list-head">
        <div class="col-4">
          <span class="label">{{ $t('globalSettings.profitCenters.key') }}</span>
        </div>
        <div class="col-12">
          <span class="label">{{ $t('globalSettings.profitCenters.leader') }}</span>
        </div>
        <div class="col-4 col-offset-2">
          <span class="label">{{ $t('globalSettings.profitCenters.updatedAt') }}</span>
        </div>
      </div>
      <div class="_items">
        <div class="row _item" v-for="(item, index) in profitCenters" :key="item.pckey">
          <div class="col-4 valign-middle">
            <span class="font-size-s font-weight-medium">{{ item.pckey.toUpperCase() }}</span>
          </div>
          <div class="col-12 valign-middle">
            <InputText alt="small" type="text" v-model="item.leader" :disabled="editMode !== index" @input="userEdited = true" @keyup.enter.native="updateRow(item)" />
          </div>
          <div class="col-4 col-offset-2 valign-middle">
            <span>{{ item.updatedAt | formatDateTime }}</span>
          </div>
          <div class="col-2">
            <div class="_buttons">
              <Button class="-light  pos-relative  -no-padding  -size-32" @click.native="updateRow(item)" v-if="editMode === index">
                <Icon class="-inline  -pos-absolute-center"><CheckSVG></CheckSVG></Icon>
              </Button>
              <Button class="-light  pos-relative  -no-padding  -size-32" @click.native="editMode = false" v-if="editMode === index">
                <Icon class="-inline  -pos-absolute-center"><CloseSVG></CloseSVG></Icon>
              </Button>
              <Button class="-light  pos-relative  -no-padding  -size-32" @click.native="editMode = index" v-if="canEdit && editMode !== index">
                <Icon class="-inline  -pos-absolute-center"><EditSVG></EditSVG></Icon>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ContentBox>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { listProfitCenters, updateProfitCenter } from '@/api/pcs.api';
import parseDates from '@/mixins/parseDates';

import Button from '@/components/atoms/Button.vue';
import Icon from '@/components/atoms/Icon.vue';
import InputText from '@/components/elements/inputs/InputText.vue';
import ContentBox from '@/components/elements/ContentBox.vue';
import EditSVG from '@/assets/icons/edit.svg';
import CheckSVG from '@/assets/icons/check.svg';
import CloseSVG from '@/assets/icons/close.svg';

export default {
  name: 'ProfitCenters',
  mixins: [parseDates],
  data() {
    return {
      editMode: false,
      userEdited: false,
      profitCenters: [],
    };
  },
  computed: {
    ...mapGetters([
      'userCan',
    ]),

    canEdit() {
      return this.userCan('editProfitCenters', this.uuid);
    },
  },
  mounted() {
    this.fetchProfitCenters();
  },
  methods: {
    fetchProfitCenters() {
      this.$store.dispatch('isLoggedIn')
        .then((token) => {
          listProfitCenters(token)
            .then((response) => {
              this.$set(this, 'profitCenters', response.data.data);
            })
            .catch((error) => {
              this.$eventBus.$emit('notificate', { message: error.response.data.message, status: error.response.status });
            });
        });
    },

    updateRow(pc) {
      if (this.canEdit && this.userEdited) {
        this.$store.dispatch('isLoggedIn')
          .then((token) => {
            updateProfitCenter(pc.pckey, pc, token)
              .then(() => {
                this.fetchProfitCenters();
                this.editMode = false;
                this.userEdited = false;
                this.$eventBus.$emit('notificate');
              })
              .catch((error) => {
                this.$eventBus.$emit('notificate', { message: error.response.data.message, status: error.response.status });
              });
          });
      } else {
        this.editMode = false;
      }
    },
  },
  components: {
    Button,
    Icon,
    InputText,
    ContentBox,
    EditSVG,
    CheckSVG,
    CloseSVG,
  },
};
</script>

<style scoped lang="scss" src="@/sass/08_modules/profit-centers.scss"></style>
